var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"full-button",attrs:{"src":require(`@/assets/images/raycaster/${_vm.fullScreen.image}.svg`)},on:{"click":_vm.makeFullScreen}})])
}
var staticRenderFns = []

export { render, staticRenderFns }